const mSpeed = 1;
const moveMax = 50;

const rotateSpeed = 0.01;
const rotateMax = -0.4;

export default class Animate {

  static move(object, axis, moveSpeed = mSpeed) {
    const origin = Math.abs(object.position[axis]);

    let isTop = false;

    setInterval(() => {
      if (!isTop && Math.abs(object.position[axis]) <= origin + moveMax) {
        object.position[axis] += moveSpeed;
      } else {
        isTop = true;
      }

      if (isTop && Math.abs(object.position[axis]) > origin) {
        object.position[axis] -= moveSpeed;
      } else {
        isTop = false;
      }
    }, 1000 / 60);
  }

  static rotate(object, axis, clockWise = false) {
    const origin = object.rotation[axis];

    let isTop = false;

    if (clockWise){
      setInterval(() => {
        if (!isTop && object.rotation[axis] <= origin - rotateMax) {
          object.rotation[axis] += rotateSpeed;
        } else {
          isTop = true;
        }
  
        if (isTop && object.rotation[axis] > origin) {
          object.rotation[axis] -= rotateSpeed;
        } else {
          isTop = false;
        }
      }, 1000 / 60);
    }
    else {
      setInterval(() => {
        if (!isTop && object.rotation[axis] >= origin + rotateMax) {
          object.rotation[axis] -= rotateSpeed;
        } else {
          isTop = true;
        }
  
        if (isTop && object.rotation[axis] < origin) {
          object.rotation[axis] += rotateSpeed;
        } else {
          isTop = false;
        }
      }, 1000 / 60);
    }
  }

}



// WEBPACK FOOTER //
// ./src/object-view/services/animate.js